

export default class ImdbMovie {
  release_year = null;
  imdb_img = null;
  imdb_imgs = null;
  star_rating = null;
  metascore = null;
  all_genres = null;
  all_writers = null;
  all_directors = null;
  all_cast = null;
  rating = null;
  release_date = null;
  duration_mins = null;
  synopsis = null;
}

